import { ObjectsStates, StateNames, Transition, TransitionArgs } from '../types/animations';

export function getTransition<TStates extends ObjectsStates>(
    obj: TStates,
    from: StateNames<TStates>,
    to: StateNames<TStates>,
    args?: TransitionArgs,
) {
    return {
        target: obj.name,
        from: from && obj.states[from],
        to: to && obj.states[to],
        ...args,
    } as const satisfies Transition;
}

export namespace getTransition {
    export function clone<T extends Transition>(t: T, mergeArgs?: TransitionArgs) {
        return {
            ...t,
            ...mergeArgs,
        } as const satisfies Transition;
    }
}
